var React = require('react');

function ClearscoreLogoSymbol (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.32.45V23.39a12.15,12.15,0,0,1,6.9,0v-16H33.59V31.71h-16a12.37,12.37,0,0,1,.5,3.46,12.17,12.17,0,0,1-.5,3.44H40.49V.45Z","key":0}),React.createElement("circle",{"cx":"5.77","cy":"35.17","r":"5.38","key":1})]);
}

ClearscoreLogoSymbol.defaultProps = {"viewBox":"0 0 40.97 40.85"};

module.exports = ClearscoreLogoSymbol;

ClearscoreLogoSymbol.default = ClearscoreLogoSymbol;
